import { Swiper, Navigation, Keyboard, A11y } from 'swiper';

const teaserFloatingCarouselSections = document.querySelectorAll(".adm-section-c29-teaser-floating");

Array.prototype.forEach.call(teaserFloatingCarouselSections, (section, index) => {
    section.classList.add(`section-${index}`);

    var swiperc29 = new Swiper(`.adm-section-c29-teaser-floating.section-${index} .swiper`, {
        modules: [Navigation, Keyboard, A11y],
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 1,
        centeredSlides: true,
        speed: 1500,
        a11y: false,
        keyboard: {
            enabled: true,
            onlyInViewPort: false
        },
        navigation: {
            nextEl: section.querySelector(".adm-c29-teaser-floating-arrow-right"),
            prevEl: section.querySelector(".adm-c29-teaser-floating-arrow-left"),
            disabledClass: "adm-arrow-disabled"
        },

        breakpoints: {
            767: {
                spaceBetween: 0
            },
            1259: {
                spaceBetween: 0
            }
        }
    });

    swiperc29.on("realIndexChange", function () {
        const paginationSwiperC29 = section.querySelector(".adm-c29-teaser-floating-currentCard");
        if (swiperc29.realIndex + 1 < 10) {
            paginationSwiperC29.innerHTML = `0${swiperc29.realIndex + 1}`;
        } else {
            paginationSwiperC29.innerHTML = swiperc29.realIndex + 1;
        }
    });

    function disableFloatingCarouselArrows() {
        section.querySelector(".adm-c29-teaser-floating-arrow-left").tabIndex = -1;
        section.querySelector(".adm-c29-teaser-floating-arrow-right").tabIndex = -1;
    }


    swiperc29.on("keyPress",
        (s) => {
            disableFloatingCarouselArrows();
            Array.prototype.forEach.call(s.slides,
                (slide, i) => {
                    slide.addEventListener("focusin",
                        () => {
                            disableFloatingCarouselArrows();
                            s.slideTo(i, 100);
                        });
                });
        });
});